
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Onewaytaxipunetomumbai() {



    const cardData =
    {
        keyword: ' One Way Taxi Pune to Mumbai',
        heading: 'Prince Cabs: One Way Taxi Pune to Mumbai',
        headingDescription: 'Prince Cabs offers affordable One Way Taxi Pune to Mumbai, perfect for airport transfers, business trips, family travel, and solo journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride along the Pune–Mumbai Expressway. With professional chauffeurs, on-time pickups, and transparent one-way fares, we provide a hassle-free travel experience. Choose Prince Cabs’ trusted one way taxi service from Pune to Mumbai for comfort, convenience, and value for money.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Today, it is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. The monument looks magical at sunset and when illuminated at night. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km long seafront promenade. Its curved road lit up at night resembles a glittering necklace. Locals and tourists love it for evening walks, jogging, and sea views. During monsoon, crashing waves create dramatic scenes. Sunsets here are breathtaking and romantic. Marine Drive is Mumbai’s favorite leisure hub."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in 1887, it features Gothic Revival architecture with domes, spires, and stained-glass windows. The structure glows beautifully when lit at night. It serves millions of commuters daily, blending history with modern life. Tourists admire its grand design while experiencing Mumbai’s lifeline—the local trains. CST is a masterpiece of heritage architecture."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are ancient UNESCO-listed rock-cut temples. Dating back to the 5th–6th centuries, the caves are dedicated to Lord Shiva. The Trimurti sculpture is the highlight, showcasing remarkable craftsmanship. Accessible by ferry from Gateway of India, the island offers peace and greenery. It is a perfect escape from the city rush. Elephanta Caves reflect India’s cultural and artistic legacy."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for street food and Bollywood connections. Visitors enjoy pav bhaji, bhel puri, and ice gola while walking along the sand. Families gather here in the evenings for leisure and sea breezes. The area is surrounded by luxury hotels and celebrity residences. Sunsets at Juhu are magical. It is the best place to experience Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it draws thousands of devotees, including celebrities and politicians. The golden dome and intricately carved doors add grandeur. Tuesdays witness the largest gatherings. Devotees believe prayers here are always fulfilled. Siddhivinayak is the spiritual heart of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and a marvel of modern engineering. It connects South Mumbai to the western suburbs. Driving across the bridge offers stunning views of the Arabian Sea. At night, its illuminated structure looks spectacular. It has reduced travel time significantly for daily commuters. The Sea Link is a modern icon of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it is visited by devotees of all faiths. The Indo-Islamic architecture stands beautifully against the sea backdrop. Accessible via a narrow causeway during low tide, it creates a unique experience. The shrine offers peace and blessings. Haji Ali is Mumbai’s landmark of spirituality and unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most famous shopping street, buzzing with shops and street vendors. It offers everything from handicrafts and clothes to jewelry and antiques. Iconic cafés like Leopold Café and Café Mondegar add to its charm. Bargaining with vendors is part of the fun. The area is always crowded with locals and tourists. Colaba reflects Mumbai’s vibrant and cosmopolitan spirit."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. It is a hotspot for local snacks like pav bhaji, kulfi, and bhel puri. Families and children enjoy the festive vibe in the evenings. Festivals and fairs make it even more colorful. The beach also offers views of Marine Drive. Chowpatty blends leisure, tradition, and culture in one place."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City is the beating heart of Bollywood, spread across 500 acres in Goregaon. It has multiple studios, artificial sets, and shooting zones. Guided tours let visitors witness behind-the-scenes of movie-making. Many films and TV shows are shot here daily. It is one of the largest film production complexes in the world. Film City defines Mumbai’s role as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a massive green sanctuary within Mumbai, spread over 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist monasteries and stupas dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and trekking trails. It is rare to find such nature inside a metro city. The park is a blend of history, adventure, and wildlife."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by lush greenery and modern skyscrapers. It is popular among birdwatchers, with sightings of kingfishers, herons, and migratory birds. Locals enjoy walking and jogging along its promenade. During monsoon, the lake looks especially scenic with misty views. Families visit for picnics and photography. Powai Lake offers calm in the heart of Mumbai."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the largest meditation domes in the world. Built in Burmese style, it houses sacred relics of Buddha. The golden dome can accommodate thousands of meditators. Visitors attend sessions and admire the stunning design. Its seaside location adds serenity and peace. The pagoda symbolizes spirituality and mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is a hub for astronomy and science enthusiasts. It hosts sky shows that explain stars, planets, and galaxies in an engaging way. The adjoining Science Centre has interactive exhibits on technology and space. Students and families love its educational yet fun atmosphere. Special events during eclipses and celestial activities attract crowds. It inspires curiosity and knowledge about space."
  }
],


  "services": [
    {
      "name": "Pune to Mumbai One Side Taxi",
      "description": "Book reliable one side taxi services from Pune to Mumbai offering hassle-free travel with professional drivers, clean and well-maintained vehicles, and punctual pickups. Perfect for those who need a straightforward trip without worrying about return arrangements."
    },
    {
      "name": "One Way Cab Pune to Mumbai Booking",
      "description": "Easily book a one way cab from Pune to Mumbai through our user-friendly platform. Choose from various vehicle options including sedans, SUVs, and MPVs to match your travel needs with transparent pricing and timely service."
    },
    {
      "name": "Pune to Mumbai One Way Innova",
      "description": "Travel comfortably in a spacious Innova cab on a one way journey from Pune to Mumbai. Ideal for families and small groups, this vehicle provides ample space, luggage capacity, and a smooth ride for a relaxed long-distance trip."
    },
    {
      "name": "Pune to Mumbai One Way Ertiga",
      "description": "Book a one way Ertiga cab from Pune to Mumbai for a comfortable and spacious ride. This 7-seater vehicle is perfect for group travels, providing enough room for passengers and luggage with air conditioning and professional driver service."
    },
    {
      "name": "Dzire One Way Cab Pune to Mumbai",
      "description": "Opt for a cost-effective Dzire cab for your one way trip from Pune to Mumbai. This sedan is ideal for solo travelers or small families looking for a clean, fuel-efficient ride with AC and courteous drivers."
    },
    {
      "name": "Pune to Mumbai Etios One Way",
      "description": "Travel in a reliable Etios sedan for your one way journey from Pune to Mumbai. Known for its comfort and smooth handling, the Etios is a great choice for budget-conscious travelers who want a hassle-free ride."
    },
    {
      "name": "Affordable One Way Taxi Pune to Mumbai",
      "description": "Avail affordable one way taxi services from Pune to Mumbai without compromising on quality. Our fleet includes well-maintained vehicles, professional drivers, and transparent pricing to ensure a comfortable and economical travel experience."
    },
    {
      "name": "Crysta One Way Pune to Mumbai",
      "description": "Experience premium one way travel with Innova Crysta cabs from Pune to Mumbai. Perfect for business travelers and VIP groups, the Crysta offers luxurious interiors, advanced comfort features, and a smooth ride over long distances."
    },
    {
      "name": "SUV One Way Cab Pune",
      "description": "Choose an SUV for your one way cab from Pune to Mumbai to enjoy spacious interiors, extra luggage capacity, and superior road handling. Ideal for larger groups or travelers with bulky baggage."
    },
    {
      "name": "AC One Way Cab Pune to Mumbai",
      "description": "Travel cool and comfortable with our AC one way cabs from Pune to Mumbai. Every vehicle in this category ensures air-conditioned interiors for a pleasant journey regardless of the weather conditions outside."
    },
    {
      "name": "Swift Dzire One Way Taxi Pune",
      "description": "Book a Swift Dzire one way taxi from Pune to Mumbai for a smooth, air-conditioned ride. This sedan offers a great balance of affordability, comfort, and fuel efficiency, making it a preferred choice for many travelers."
    },
    {
      "name": "Pune to Mumbai Fast One Way Cab",
      "description": "Need to reach Mumbai quickly? Our fast one way cab service from Pune prioritizes timely departures and optimized routes to ensure you arrive at your destination swiftly and safely."
    },
    {
      "name": "Pune to Mumbai One Way Travel",
      "description": "Enjoy flexible one way travel options from Pune to Mumbai with a wide range of vehicles and personalized service. Perfect for business trips, airport drops, or casual travel with no return commitments."
    },
    {
      "name": "Best One Way Taxi Pune to Mumbai",
      "description": "Choose the best one way taxi service from Pune to Mumbai with verified drivers, clean vehicles, and excellent customer support ensuring a comfortable and safe journey every time."
    },
    {
      "name": "One Way Car Rental Pune to Mumbai",
      "description": "Rent a car on a one way basis from Pune to Mumbai with driver included. Enjoy the convenience of point-to-point travel without worrying about round-trip scheduling or extra costs."
    }
  ],
  "tableData": [
    ["Pune to Mumbai One Side Taxi", "One Way Cab Pune to Mumbai Booking"],
    ["Pune to Mumbai One Way Innova", "Pune to Mumbai One Way Ertiga"],
    ["Dzire One Way Cab Pune to Mumbai", "Pune to Mumbai Etios One Way"],
    ["Affordable One Way Taxi Pune to Mumbai", "Crysta One Way Pune to Mumbai"],
    ["SUV One Way Cab Pune", "AC One Way Cab Pune to Mumbai"],
    ["Swift Dzire One Way Taxi Pune", "Pune to Mumbai Fast One Way Cab"],
    ["Pune to Mumbai One Way Travel", "Best One Way Taxi Pune to Mumbai"],
    ["One Way Car Rental Pune to Mumbai"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable One Way Taxi Service from Pune to Mumbai",
    "WhyChoosedescription": "Prince Cabs offers trustworthy and convenient one way taxi services from Pune to Mumbai, ideal for business travelers, tourists, and families. Covering approximately 150 kilometers, our service ensures punctual pickups, smooth rides, and a hassle-free journey, allowing you to reach Mumbai comfortably and on time."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet includes a range of vehicles such as sedans and SUVs like Swift Dzire, Ertiga, and Innova, all well-maintained and equipped with comfortable seating, ample luggage space, and air conditioning to make your one way trip from Pune to Mumbai pleasant."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are highly experienced and familiar with the Pune to Mumbai route. They ensure safe driving, efficient navigation, and timely breaks, guaranteeing a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Your Convenience",
    "WhyChoosedescription": "Prince Cabs offers easy and flexible booking options for one way trips, with instant confirmation through phone, WhatsApp, or online booking platforms. We also provide flexible cancellation policies to suit your travel needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our one way taxi pricing from Pune to Mumbai is clear and competitive, including fuel, tolls, driver allowances, and taxes. We accept multiple secure payment methods such as UPI, credit/debit cards, net banking, and cash."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Vehicles for Your Protection",
    "WhyChoosedescription": "All our vehicles are thoroughly cleaned and sanitized before every trip. Regular maintenance and safety features such as airbags and seat belts ensure your safety and comfort during the journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
    "WhyChoosedescription": "Our dedicated customer care team is available round the clock to assist you with bookings, itinerary changes, and any travel-related queries, ensuring a smooth and stress-free one way taxi experience from Pune to Mumbai."
  }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer one way taxi services from Pune to Mumbai?',
        answer: 'Yes, Prince Cabs provides reliable and affordable one way taxi services from Pune to Mumbai, perfect for quick trips or one-way travel.',
    },
    {
        question: 'What types of vehicles are available for one way Pune to Mumbai taxi?',
        answer: 'We offer a variety of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the Pune to Mumbai one way taxi journey take?',
        answer: 'The trip generally takes around 3 to 4 hours, depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one way taxi for immediate travel?',
        answer: 'Yes, Prince Cabs offers flexible booking options including instant and advance reservations for one way taxi services.',
    },
    {
        question: 'Are the one way taxis sanitized and well-maintained?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort.',
    },
    {
        question: 'What is the fare for one way taxi from Pune to Mumbai?',
        answer: 'Fares depend on the vehicle type and travel time. Contact Prince Cabs for the most accurate and competitive pricing.',
    },
    {
        question: 'How do I book a one way taxi from Pune to Mumbai?',
        answer: 'You can book easily through our website or by calling our customer support with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Sachin Rane",
        position: "Business Traveler",
        text: "I frequently use Prince Cabs for one way taxi rides from Pune to Mumbai. The service is punctual and comfortable.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-1.png",
    },
    {
        name: "Ms. Neha Sharma",
        position: "Solo Traveler",
        text: "Booking a one way taxi from Pune to Mumbai was quick and easy with Prince Cabs. The driver was courteous and the car was clean.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-2.png",
    },
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "One Way Taxi Pune to Mumbai",
  "description": "Affordable and reliable one way taxi services from Pune to Mumbai including Innova, Ertiga, Dzire, Etios, Swift Dzire, Crysta, SUV, and AC cabs for fast and comfortable travel.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mumbai One Side Taxi",
    "One Way Cab Pune to Mumbai Booking",
    "Pune to Mumbai One Way Innova",
    "Pune to Mumbai One Way Ertiga",
    "Dzire One Way Cab Pune to Mumbai",
    "Pune to Mumbai Etios One Way",
    "Affordable One Way Taxi Pune to Mumbai",
    "Crysta One Way Pune to Mumbai",
    "SUV One Way Cab Pune",
    "AC One Way Cab Pune to Mumbai",
    "Swift Dzire One Way Taxi Pune",
    "Pune to Mumbai Fast One Way Cab",
    "Pune to Mumbai One Way Travel",
    "Best One Way Taxi Pune to Mumbai",
    "One Way Car Rental Pune to Mumbai"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};







    return (
        <div>
<Helmet>
  <title>One Way Taxi Pune to Mumbai | Innova, Dzire, Ertiga One Way Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable one way taxi services from Pune to Mumbai including Innova, Ertiga, Dzire, Etios, Swift Dzire, Crysta, SUV, and AC cabs for fast and comfortable travel."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai One Side Taxi, One Way Cab Pune to Mumbai Booking, Pune to Mumbai One Way Innova, Pune to Mumbai One Way Ertiga, Dzire One Way Cab Pune to Mumbai, Pune to Mumbai Etios One Way, Affordable One Way Taxi Pune to Mumbai, Crysta One Way Pune to Mumbai, SUV One Way Cab Pune, AC One Way Cab Pune to Mumbai, Swift Dzire One Way Taxi Pune, Pune to Mumbai Fast One Way Cab, Pune to Mumbai One Way Travel, Best One Way Taxi Pune to Mumbai, One Way Car Rental Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onewaytaxipunetomumbai ;